document.addEventListener("DOMContentLoaded", function () {
  const salesEl = document.getElementById("sales-count");
  if (!salesEl) return;

  // Pegando ID do produto via atributo Liquid injetado
  const productId = document.body.dataset.productId;
  if (!productId) return;

  // Simulando valor fixo mas variável por produto
  const base = parseInt(productId, 10);
  const randomSold = 8000 + (base % 4001); // 8000 a 12000

  salesEl.innerText = `${randomSold.toLocaleString("pt-BR")} vendidos`;
});
